import React from "react";
import { Marker, APIProvider, Map } from "@vis.gl/react-google-maps";
import { MapStyleController } from "./Components/MapStylesController";
const apiKey = "AIzaSyA9UZdAKSZyU-HkqVDIgrYk4x9TCtqN_cA";
const MapView = ({
  element,
  elementSize
}) => {
  const mapSettings = element?.settings;
  const location = {
    lat: mapSettings?.location?.lat,
    lng: mapSettings?.location?.lng
  };
  const isSatellite = mapSettings?.isSatellite;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      height: "100%",
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement(APIProvider, {
    apiKey: apiKey
  }, /*#__PURE__*/React.createElement("a", {
    href: `https://www.google.com/maps/search/?api=1&query=${location.lat},${location.lng}`,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(Map, {
    defaultCenter: location,
    center: location,
    zoom: mapSettings?.zoom || 12,
    mapTypeControl: false,
    cameraControl: false,
    zoomControl: false,
    streetViewControl: false,
    fullscreenControl: false,
    mapTypeId: isSatellite ? "hybrid" : "roadmap",
    scrollwheel: false,
    style: {
      width: "100%",
      height: `${elementSize?.height}px`
    }
  }, /*#__PURE__*/React.createElement(MapStyleController, {
    mapStyle: mapSettings?.style,
    showLabels: mapSettings?.showLabels
  }), /*#__PURE__*/React.createElement(Marker, {
    position: location
  })))));
};
export { MapView };
//# sourceMappingURL=MapView.js.map